import { CHECKLIST_TYPES } from "models";

import type { Checklist } from "models";
import type { SortablePendingChecklists } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists";
import type { SortableInterventionPendingChecklists } from "modules/PendingChecklistsDashboard/components/InterventionChecklists/components/InterventionChecklistsModal";
import type { SortablePinPendingChecklists } from "modules/PendingChecklistsDashboard/components/PinChecklists/components";
import type { SortableServicePendingChecklist } from "modules/PendingChecklistsDashboard/components/ServiceChecklists/components";

export const checkIfAannameChecklistsAreAtTheTop = (
  sortedPendingChecklists: SortablePinPendingChecklists[] | SortableServicePendingChecklist[] | SortablePendingChecklists[] | SortableInterventionPendingChecklists[],
  checklists: Checklist[]
) => {
  const sortedChecklistsWithType = sortedPendingChecklists.map(spc => checklists.find(checklist => checklist.id === spc.checklist_id));
  const aannameCount = sortedChecklistsWithType.reduce((acc, el) => (el?.checklist_type === CHECKLIST_TYPES.Aanname ? acc + 1 : acc), 0);
  if (aannameCount === 0) return true;

  const sortedPPChecklistsWithTypeSubset = sortedChecklistsWithType.slice(0, aannameCount);
  return sortedPPChecklistsWithTypeSubset.every(ac => ac?.checklist_type === CHECKLIST_TYPES.Aanname);
};
